
import FormInput from "./FormInput";
import FormTextarea from "./FormTextarea";
import Btn from "./Btn";
import Page from "./Page.vue";
export default {
    components: {Page, Btn, FormTextarea, FormInput},
    props: ['page'],
    data() {
        return {
            seo: false,
            process: false,
        }
    },
    computed: {
        email() {
            return this.$config.siteCountry === 'kz' ? 'info@sevensix.kz' : 'info@sevensix.sport';
        },
    },
    methods: {
        async submit(){
            this.process = true;
            try {
                let response = await this.$axios.post('/api/v1/seo/about', {
                    id: this.page.id,
                    seo_h1: this.page.seo_h1,
                    seo_title: this.page.seo_title,
                    seo_description: this.page.seo_description,
                });
                this.process = false;
                this.seo = false;
            } catch (e) {
                if (e.response.status === 422) {
                    this.error = 'Некорректно отправлена форма';
                } else {
                    this.error = 'Системная ошибка, попробуйте позже';
                }
                alert(this.error);
                this.process = false;
            }
        },
    },
}
